import { render, staticRenderFns } from "./NoAccessPlaceholder.vue?vue&type=template&id=31bdaa5f&scoped=true&"
import script from "./NoAccessPlaceholder.vue?vue&type=script&lang=js&"
export * from "./NoAccessPlaceholder.vue?vue&type=script&lang=js&"
import style0 from "./NoAccessPlaceholder.vue?vue&type=style&index=0&id=31bdaa5f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bdaa5f",
  null
  
)

export default component.exports